<template>
  <div>
    <overwatchLoader id='loader' v-if='!site'/>
    <model path="/static/mercure/mercureRatesHorizontalV1/" :content="model" :format='1610'></model>
    <div id='mercureRatesHorizontalV1' class='d-flex flex-column justify-content-around' v-if='site'>
      <div id='master' class='d-flex flex-column justify-content-around'>
        <pageHead :site-name="siteName"></pageHead>
        <pageTitles></pageTitles>
        <div id='main' class='d-flex flex-row justify-content-around'>
          <rates class='left' :ratesLg='ratesLg'></rates>
          <services class='right' :servicesLg='ratesLg'></services>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from './header'
import Titles from './titles'
import Rates from './rates/rates'
import Services from './services/services'
import OverwatchLoader from '../../../../loader/overwatch'
import Change from './right/change/change'
import Hosts from './right/hosts/hosts'
import Messages from './right/messages/messages'
import model from '../../../../debug/model'

export default {
  name: 'MercureRatesHorizontalV1',
  components: {
    pageHead: Header,
    pageTitles: Titles,
    rates: Rates,
    services: Services,
    change: Change,
    hosts: Hosts,
    messages: Messages,
    OverwatchLoader,
    model
  },
  data: function () {
    return {
      rightOrder: ['change', 'hosts', 'messages'],
      model: ['mercure_infos_legales_sur tablette_V2a.jpg', 'mercure_infos_legales_sur tablette_V2b.jpg'],
      rightIndex: -1,
      msgCurrentPage: 1,
      goNextComponent: true
    }
  },
  mounted () {
    this.$dm.getData(this.$route) // get data on start
    // this.alternates()
  },
  computed: {
    ratesLg () {
      let rates = this.site && this.site.get('rates')
      if (rates) {
        let data = rates.get('data')
        if (data) {
          return {
            lg1: data[data.languages[0].id],
            lg2: data[data.languages[1].id]
          }
        } else {
          return null
        }
      } else {
        return null
      }
    },
    changeLg () {
      let change = this.site && this.site.get('change')
      if (change) {
        let data = change.get('data')
        if (data) {
          return {
            lg1: data[data.languages[0].id].exchangeRate,
            lg2: data[data.languages[1].id].exchangeRate
          }
        } else {
          return null
        }
      } else {
        return null
      }
    },
    messages () {
      try {
        return this.site && this.site.get('messages').get('data')
      } catch (error) {
        return null
      }
    },
    netStatus () {
      return this.$store.state.connected
    },
    site () {
      let site = this.$store.getters.site
      console.log('site()', site)
      return site
    },
    user () {
      return this.$store.getters.user
    },
    device () {
      return this.$store.getters.device
    },
    rightStatus () {
      return this.rightOrder[this.rightIndex]
    },
    siteName () {
      try {
        return this.site.get('rates').get('data').siteName
      } catch (e) {
        return ''
      }
    },
    page () {
      return this.$route.query.page
    },
    transitionName () {
      if (this.page) {
        return 'off' // no transition if page is forced
      } else {
        return 'fade'
      }
    }
  },
  watch: {
    netStatus (newStatus, oldStatus) {
      console.log('netStatus update', oldStatus, newStatus)
      // Get data on connection status change
      if (oldStatus) { // getData must not be done the first time
        console.log('netStatus getdata')
        this.$dm.getData(this.$route)
      }
    },
    user (newUser, oldUser) {
      console.log('User update', oldUser, newUser)
      // Get data when user is logged
      if (oldUser && newUser) {
        console.log('user getdata')
        this.$dm.getData(this.$route)
      }
    },
    device (newDevice, oldDevice) {
      console.log('Device update', oldDevice, newDevice)
      // refresh data on device update
      if (oldDevice && oldDevice._objCount && newDevice) {
        console.log('device getdata')
        this.$dm.getData(this.$route)
      }
    },
    site (newSite, oldSite) {
      console.log('Site updated', oldSite, newSite)
    }
  },
  methods: {
    alternates () {
      if (this.page) { // for test purpose
        this.rightIndex = this.page
      } else {
        let display =
          (this.changeLg && this.changeLg.lg1.rates.length) ||
          (this.ratesLg && this.ratesLg.lg1.inCharge.length) ||
          (this.messages && this.messages.clients_messages.length)
        if (!display) {
          setTimeout(this.alternates, 1000)
          return
        }
        if (this.goNextComponent) {
          this.rightIndex++
        }
        if (this.rightIndex >= this.rightOrder.length) {
          this.rightIndex = 0
        }
      }
      let len = 0
      switch (this.rightStatus) {
        case 'change':
          this.goNextComponent = true
          len = this.changeLg && this.changeLg.lg1.rates.length
          if (!len) {
            this.alternates()
            return
          }
          break
        case 'hosts':
          this.goNextComponent = true
          if (this.ratesLg) {
            len = this.ratesLg && this.ratesLg.lg1.inCharge.length
          }
          if (!len) {
            this.alternates()
            return
          }
          break
        case 'messages':
          this.goNextComponent = true
          len = this.messages && this.messages.clients_messages.length
          if (!len) {
            this.alternates()
            return
          }
          if (this.$refs.messages.nextPage()) {
            this.goNextComponent = false
          }
          break
      }
      setTimeout(this.alternates, 7000)
    }
  }
}
</script>

<style lang='scss' scoped>
$srcWidth : 1920;
$srcHeight : 1200;
@import "../../../_mercure.scss";

#mercureRatesHorizontalV1 {
  width: 160vh; // https://www.alsacreations.com/article/lire/1490-comprendre-le-viewport-dans-le-web-mobile.html
  height: 100vh;
  background-color: white;
  
  #master {
    position: relative;
    width: 160vh;
    height: 100vh;
    // border: 1px solid black

    #main {
      @include heightPercent(977);

      .left {
        @include widthPercent(895);
        margin-left: 1vh;
      }

      .right {
        @include widthPercent(887);
      }
    }
  }
}

</style>

<style lang='scss'>
@import "../../../_mercure.scss";
@import "../../../../../../scss/global.scss";

#app {
  @extend .gradientBackground;
}

#mercureRatesHorizontalV1 {

.lg1 {
  color: $purple;
}

.lg2 {
  color: $gold;
}

}
</style>


// WEBPACK FOOTER //
// src/components/mercure/rates/horizontal/v1/mercureRatesHorizontalV1.vue